import { colors } from "@mui/material";

const white = "#FFFFFF";
const black = "#080808";

const _customObj = {
  common: {
    black,
    white,
  },
  primary: {
    contrastText: white,
    main: "#DAB567",
  },
  secondary: {
    contrastText: white,
    main: "#6a7bff",
  },
  accent: {
    contrastText: white,
    dark: "#444444",
    main: "#0b2c5a",
    light: "#999999",
  },
  none: {
    contrastText: white,
    main: "#ffffff5e",
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  alert: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.grey[900],
    secondary: colors.grey[800],
    link: colors.blue[600],
  },
  background: {
    default: "#F4F6F8",
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};

export default _customObj;
